<template>
  <client-only>
    <div :class="isNotHomePage && 'min-[5000px]:hidden'">
      <OvaOrderEditDrawer
        v-if="orderEditLog"
        :order-edit-log="orderEditLog"
        @close="$emit('close-order-edit-log')"
      />
      <NuxtPage />
    </div>
    <div v-if="isNotHomePage" class="hidden min-[5000px]:flex h-screen justify-center items-center">
      <h1 class="text-3xl">{{ $t("bigDescText") }}</h1>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineProps<{
  orderEditLog?: any | null
}>()

defineEmits<{
  (event: 'close-order-edit-log'): void
}>()

const route = useRoute()

const isNotHomePage = computed(() => {
  if (!route.path) return true;
  const pathStr = String(route.path);
  
  if (pathStr.includes('privacy-policy') || pathStr.includes('terms-of-use')) return true;
  return route.name && !String(route.name).startsWith('index');
})
</script>

<style scoped></style>
